import React from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import { MdOutlinePlaylistAdd, MdAddTask } from 'react-icons/md'
import { FaFlagCheckered } from 'react-icons/fa';


const NavMenu = () => {
    const location = useLocation();
    return (
        <div className='flex justify-start items-center px-4'>
            <NavLink to='/airdrop' exact={true}>
                <div className={`flex flex-col items-center px-2 z-100 pb-4 ${location.pathname === '/airdrop' ? 'border-b-4 border-primary' : 'border-b-4 border-slate-100'} cursor-pointer`}>
                    <div className='w-[64px]'>
                        <span className='w-full h-full flex items-center justify-center'>
                            <MdOutlinePlaylistAdd size='22px' className='fill-rose-600' />
                        </span>
                    </div>
                    <div className='text-xs mt-3 text-center  text-zinc-800'>
                        Add Airdrop
                    </div>
                </div>
            </NavLink>
            <NavLink to='/airdrop/do' exact={true} a>
                <div className={`flex flex-col items-center px-2 z-100 pb-4 ${location.pathname === '/airdrop/do' ? 'border-b-4 border-primary' : 'border-b-4 border-slate-100'} cursor-pointer`}>
                    <div className='w-[64px]'>
                        <span className='w-full h-full flex items-center justify-center'>
                            <MdAddTask size='22px' className='fill-purple-700' />
                        </span>
                    </div>
                    <div className='text-xs mt-3 text-center  text-zinc-800'>
                        Garap Airdrop
                    </div>
                </div>
            </NavLink>
            <NavLink to='/airdrop/view' exact={true} a>
                <div className={`flex flex-col items-center px-2 z-100 pb-4 ${location.pathname === '/airdrop/view' ? 'border-b-4 border-primary' : 'border-b-4 border-slate-100'} cursor-pointer`}>
                    <div className='w-[64px]'>
                        <span className='w-full h-full flex items-center justify-center'>
                            <FaFlagCheckered size='22px' className='fill-green-500' />
                        </span>
                    </div>
                    <div className='text-xs mt-3 text-center  text-zinc-800'>
                        Garapan
                    </div>
                </div>
            </NavLink>
        </div>
    )
}

export default NavMenu
